import { sbRespNotificationUnavailableItemModalConfig } from './SbRespNotificationUnavailableItem/sbRespnotificationUnavailableItemConfig';
import { sbRespNotificationTradeOnboardingConfig } from './SbRespNotificationTradeOnboarding/sbRespNotificationTradeOnboardingConfig';

export const sbRespNotifications = [
    sbRespNotificationUnavailableItemModalConfig,
    sbRespNotificationTradeOnboardingConfig,
];
